/*
 * 拖拽控制条
 * */
'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../helper/assetsHelper');
var i18nHelper = require('../helper/i18n');
var runtimeHelper = require('../helper/runtimeHelper');

var NavigationBar = React.createClass({
  propTypes: {
    domSize: React.PropTypes.object.isRequired,
    onOpenNext: React.PropTypes.func.isRequired,
    onOpenPrev: React.PropTypes.func.isRequired,
    onOpenHome: React.PropTypes.func.isRequired,
    onPlayback: React.PropTypes.func.isRequired,
    controlPanel: React.PropTypes.bool.isRequired,
    onTogglePanelVisibility: React.PropTypes.func.isRequired,
    onToggleRemarkVisibility: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      top: 50,
      right: 350, // FIXME: 恢复该值
      moved: false,
      expand: true
    };
  },
  render: function () {
    var style = {
      top: this.state.top,
      right: this.state.right
    };
    var panelStyle = {};
    if (!this.state.expand) {
      panelStyle.borderRight = 'none';
    } else {
      panelStyle.borderRight = '1px solid #666';
    }
    var expandIcon = this.state.expand ? assetsHelper.getAsset('shrink.png') : assetsHelper.getAsset('blowup.png');
    return (
      <div className="navigation-bar" style={style} onMouseDown={this.onTitleClick}>
        <div className="navigation-bar-title" onDoubleClick={this.onToggleExpand}>
          <img onClick={this.onToggleExpand} width="11" height="11"
               src={expandIcon}/>
        </div>
        <div className="navigation-actions">
          {
            this.props.controlPanel &&
            <div className="panel panel-left" style={panelStyle}>
              <span className="action" onClick={this.props.onTogglePanelVisibility}>
                <img src={assetsHelper.getAsset('menu.png')} alt=""/>
                <span className="tooltip">{i18nHelper.get('SETTINGS')}</span>
              </span>
            </div>
          }
          { this.state.expand &&
          <div className="navs">
            <span className="action" onClick={this.props.onOpenHome}>
              <img src={assetsHelper.getAsset('home.png')}/>
              <span className="tooltip">{i18nHelper.get('HOME')}</span>
            </span>
            <span className="action" onClick={this.props.onOpenPrev}>
              <img src={assetsHelper.getAsset('prev.png')}/>
              <span className="tooltip">{i18nHelper.get('PREV')}</span>
            </span>
            <span className="action" onClick={this.props.onOpenNext}>
              <img src={assetsHelper.getAsset('next.png')}/>
              <span className="tooltip">{i18nHelper.get('NEXT')}</span>
            </span>
            <span className="action" onClick={this.props.onPlayback}>
              <img src={assetsHelper.getAsset('playback.png')}/>
              <span className="tooltip">{i18nHelper.get('PLAYBACK')}</span>
            </span>
          </div>
          }
          {this.state.expand &&
          <div className="panel panel-right">
            <span className="action" onClick={this.props.onToggleRemarkVisibility}>
              <img src={assetsHelper.getAsset('remark.png')} alt=""/>
              <span className="tooltip">{i18nHelper.get('RIGHT_PANEL')}</span>
            </span>
            {runtimeHelper.canReview() &&
            <span className="action" onClick={this.props.onToggleCommentMode}>
              <img src={assetsHelper.getAsset('comment.png')} alt=""/>
              <span className="tooltip">{i18nHelper.get('MARK')}</span>
            </span>
            }
          </div>
          }
        </div>
      </div>
    );
  },
  onToggleExpand: function () {
    this.setState({
      expand: !this.state.expand
    });
  },
  onTitleClick: function (e) {
    var dom = ReactDOM.findDOMNode(this);
    this.startPosition = {
      top: this.state.top,
      right: this.state.right
    };
    this.dom = dom;
    this.width = dom.offsetWidth;
    this.height = dom.offsetHeight;
    document.addEventListener('mousemove', this.onMove);
    document.addEventListener('mouseup', this.onEnd);
    e.stopPropagation();
    e.preventDefault();
    this.startInfo = {
      x: e.pageX,
      y: e.pageY
    };
  },
  onMove: function (e) {
    var deltaX = e.pageX - this.startInfo.x;
    var deltaY = e.pageY - this.startInfo.y;
    var dom = this.dom;
    var top = this.startPosition.top + deltaY;
    var right = this.startPosition.right - deltaX;
    top = Math.min(Math.max(0, top), this.props.domSize.height - this.height);
    right = Math.min(Math.max(0, right), this.props.domSize.width - this.width);
    dom.style.top = top + 'px';
    dom.style.right = right + 'px';

    this.deltaX = deltaX;
    this.deltaY = deltaY;
    e.stopPropagation();
    e.preventDefault();
  },
  onEnd: function (e) {
    this.startInfo = null;
    var self = this;
    this.setState({
      top: parseInt(this.dom.style.top, 10),
      right: parseInt(this.dom.style.right, 10)
    }, function () {
      document.removeEventListener('mousemove', self.onMove);
      document.removeEventListener('mouseup', self.onEnd);
    });
    e.stopPropagation();
    e.preventDefault();
  }
});

module.exports = NavigationBar;


// WEBPACK FOOTER //
// ./src/views/NavigationBar.jsx